import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Crown, Mail } from 'lucide-react';

interface SubscriptionRequiredModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function SubscriptionRequiredModal({ open, onOpenChange }: SubscriptionRequiredModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <div className="w-14 h-14 rounded-full bg-accent/20 flex items-center justify-center mx-auto mb-4">
            <Crown className="w-7 h-7 text-accent" />
          </div>
          <DialogTitle className="text-center text-xl">Abonelik Gerekli</DialogTitle>
          <DialogDescription className="text-center">
            Kullanıcı yönetimi özelliği için <span className="font-medium text-foreground">Premium</span> veya{' '}
            <span className="font-medium text-foreground">Elite</span> abonelik gereklidir.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-2">
          <p className="text-sm text-muted-foreground text-center">
            Abonelik planları hakkında bilgi almak ve yükseltme yapmak için bizimle iletişime geçin.
          </p>

          <a
            href="mailto:hello@idatech.online"
            className="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-lg bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors"
          >
            <Mail className="w-4 h-4" />
            hello@idatech.online
          </a>

          <Button variant="outline" className="w-full" onClick={() => onOpenChange(false)}>
            Kapat
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
